import {updateField} from 'vuex-map-fields'

export default {
    updateField
}